const { debounce } = window.BAO.Utils
class StickyColumn extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.detectHeights()
  }

  setupListeners () {
    super.setupListeners()
    this.detectHeights = this.detectHeights.bind(this)
    const debouncedDetectHeights = debounce(this.detectHeights, 250)
    this.listeners.add(window, 'resize', debouncedDetectHeights.bind(this))

    this.listeners.add(this, 'click', this.handleClick.bind(this))

    this.listeners.add(document, 'AFTER_GIFT_FINDER_RENDER', this.detectHeights)
    this.listeners.add(document, 'AFTER_COLLECTION_RENDER', this.detectHeights)
  }

  detectHeights () {
    const top = this.viewportHeight - this.elementHeight

    this.els.sticky.element.style.setProperty('position', 'sticky')
    this.els.sticky.element.style.setProperty('top', `${top < 0 ? top : 40}px`)
  }

  handleClick () {
    this.detectHeights()
  }

  get viewportHeight () {
    return Math.max(
      document.documentElement.clientHeight || 0,
      window.innerHeight || 0,
    )
  }

  get elementHeight () {
    return this.els.sticky.element.getBoundingClientRect().height
  }
}

if (!customElements.get('sticky-column')) {
  customElements.define('sticky-column', StickyColumn)
}

class StickyToBottomColumn extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    if (!this.els.sticky?.exists) return
    if (window.matchMedia('(max-width: 1023px)').matches) return

    this.calculateAnchor()
  }

  setupListeners () {
    super.setupListeners()

    if (!this.els.sticky?.exists) return
    if (window.matchMedia('(max-width: 1023px)').matches) return

    window.addEventListener('scroll', this.onScroll.bind(this), {
      passive: true,
    })
  }

  onScroll () {
    const previouslyKnown = this.lastKnownY || null

    this.lastKnownY = window.scrollY
    this.scrollDirection = previouslyKnown < this.lastKnownY ? 'down' : 'up'

    this.calculateAnchor(this.scrollDirection)
  }

  calculateAnchor (scrollDirection) {
    if (
      this.elementHeight < this.viewportHeight ||
      scrollDirection === undefined
    ) {
      this.createTopAnchor()

      return
    }

    if (
      this.elementTop < this.headerOffset &&
      this.elementBottom > this.viewportHeight
    ) {
      this.removeAnchor()
    }

    if (scrollDirection === 'up') {
      if (
        this.elementBottom === this.viewportHeight ||
        this.elementTop < this.headerOffset
      ) {
        this.removeAnchor()
      }

      if (this.elementTop >= this.headerOffset) {
        this.createTopAnchor()
      }
    }

    if (scrollDirection === 'down') {
      if (
        this.elementTop === this.headerOffset ||
        this.elementBottom > this.viewportHeight
      ) {
        this.removeAnchor()
      }

      if (this.elementBottom <= this.viewportHeight) {
        this.createBottomAnchor()
      }
    }
  }

  createTopAnchor () {
    if (this.elementTop === this.headerOffset) return

    this.els.sticky.element.style.position = 'sticky'
    this.els.sticky.element.style.top = `${0 + this.headerOffset}px`
  }

  createBottomAnchor () {
    if (this.elementBottom === this.viewportHeight) return

    this.els.sticky.element.style.position = 'sticky'
    this.els.sticky.element.style.top = `${this.viewportHeight -
      this.elementHeight}px`
  }

  removeAnchor () {
    if (this.els.sticky.element.style.position === 'relative') return

    this.els.sticky.element.style.position = 'relative'
    this.els.sticky.element.style.top = `${this.newTop}px`
  }

  set scrollDirection (scrollDirection) {
    if (scrollDirection !== this._scrollDirection) {
      this.newTop = this.elementTop - this.elementParentTop
    }

    this._scrollDirection = scrollDirection
  }

  get scrollDirection () {
    return this._scrollDirection
  }

  get viewportHeight () {
    return Math.max(
      document.documentElement.clientHeight || 0,
      window.innerHeight || 0,
    )
  }

  get elementHeight () {
    return this.els.sticky.element.getBoundingClientRect().height
  }

  get elementTop () {
    return this.els.sticky.element.getBoundingClientRect().top
  }

  get elementBottom () {
    return this.els.sticky.element.getBoundingClientRect().bottom
  }

  get elementParentTop () {
    return this.els.sticky.element.parentElement.getBoundingClientRect().top
  }

  get headerOffset () {
    const header = document.querySelector('header-scroll')
    const headerHeight = header.getBoundingClientRect().bottom
    const headerTransform = header.style.transform

    if (headerHeight < headerTransform) {
      return 0
    } else {
      return headerHeight
    }
  }
}

if (!customElements.get('sticky-to-bottom-column')) {
  customElements.define('sticky-to-bottom-column', StickyToBottomColumn)
}
